// src/pages/institutions/InstitutionPageShell.jsx
import React from "react";
import { createPortal } from "react-dom";
import TopBarCenter from "@/sot/primitives/TopBarCenter.jsx";

import InstitutionTopBar, {
  INSTITUTION_TOP_BAR_NAVIGATION,
} from "./InstitutionTopBar.jsx";

/**
 * One Institution content rail owns the shared 24px page start below the
 * DesktopHeader and the only header-to-content gap. Pages with a subtitle use
 * the compact shared rhythm; Dashboard preserves its established no-subtitle
 * breathing room. Page components must not add title or top-spacing wrappers.
 */
export default function InstitutionPageShell({
  title = "",
  subtitle = "",
  navigation = INSTITUTION_TOP_BAR_NAVIGATION.NONE,
  onBack,
  backLabel,
  headerActions = null,
  flushTop = false,
  centered = false,
  className = "",
  contentClassName = "",
  children,
}) {
  const hasHeader = Boolean(title);

  return (
    <section
      className={`institution-page-shell ${flushTop ? "" : "pt-6"} ${className}`.trim()}
      data-testid="institution-page-shell"
    >
      {hasHeader ? (
        centered ? (
          <TopBarCenter
            title={title}
            subtitle={subtitle}
            onBack={onBack}
            backLabel={backLabel}
            showBack={navigation === INSTITUTION_TOP_BAR_NAVIGATION.BACK}
            wrapTitle
            right={headerActions}
            margin="mb-0"
          />
        ) : (
          <InstitutionTopBar
            title={title}
            subtitle={subtitle}
            navigation={navigation}
            onBack={onBack}
            backLabel={backLabel}
            actions={headerActions}
          />
        )
      ) : null}

      <div
        className={[
      // Subtitle-bearing pages use the compact shared rhythm. Pages without a
      // subtitle (for example Dashboard) retain their established title-to-body
      // breathing room.
      hasHeader ? (subtitle ? "mt-4" : "mt-8") : "",
          "institution-page-shell__content",
          contentClassName,
        ]
          .filter(Boolean)
          .join(" ")}
      >
        {children}
      </div>
      {import.meta.env.DEV && typeof document !== "undefined" ? createPortal(
        <details className="institution-release-diagnostic" data-testid="institution-release-diagnostic">
          <summary>4028 source</summary>
          <span>{import.meta.env.VITE_AFRIMED_RELEASE_BRANCH}@{import.meta.env.VITE_AFRIMED_RELEASE_SHA}</span>
        </details>,
        document.body,
      ) : null}
    </section>
  );
}
